import { render } from "./Tabs.vue?vue&type=template&id=7ec61de0&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=7ec61de0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec61de0"],['__file',"src/views/index/components/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec61de0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec61de0', __exports__)) {
    console.log('reload')
    api.reload('7ec61de0', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=7ec61de0&scoped=true", () => {
    console.log('re-render')
    api.rerender('7ec61de0', render)
  })

}


export default __exports__